"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPerformanceBands = void 0;
var performance_band_model_1 = require("../models/performance-band.model");
var curriculumId_enum_1 = require("./curriculumId.enum");
exports.DefaultPerformanceBands = [
    new performance_band_model_1.PerformanceBand({
        code: 'not-proficient',
        min: 0,
        max: 39.99999,
        curriculum: curriculumId_enum_1.CurriculumId.EurekaMath,
    }),
    new performance_band_model_1.PerformanceBand({
        code: 'partially-proficient',
        min: 40,
        max: 59.99999,
        curriculum: curriculumId_enum_1.CurriculumId.EurekaMath,
    }),
    new performance_band_model_1.PerformanceBand({
        code: 'proficient',
        min: 60,
        max: 89.99999,
        curriculum: curriculumId_enum_1.CurriculumId.EurekaMath,
    }),
    new performance_band_model_1.PerformanceBand({
        code: 'highly-proficient',
        min: 90,
        max: 100,
        curriculum: curriculumId_enum_1.CurriculumId.EurekaMath,
    }),
];
